(function () {
    /**
     * Interview main module
     *
     * @type {angular.Module|module}
     */
    var interviewModule = angular.module('harriApp.interviewV2');

    /**
     * Interview main component controller
     *
     * @param $scope
     * @constructor
     */
    var InterviewCalendarV2Controller = function ($scope) {};

    /**
     * Component options
     */
    var InterviewCalendarV2Component = {
        bindings: {},
        templateUrl: '../modules/interview-v2/interview-calendar-v2/interview-calendar-v2.html',
        controller: ['$scope', InterviewCalendarV2Controller],
        controllerAs: 'component'
    };

    interviewModule
        .component('interviewCalendarV2', InterviewCalendarV2Component);
})();